<template>
  <nav>
    <EventCard v-if='events' v-for='event in clampObjectArray(futureEvents, max)' :event='event' :key='event.id' />
  </nav>
</template>

<script setup>
import { useStore } from '@/KQL.js';
import { clamp, filterItems, pageFromPath, clampObjectArray, filterPublicPages } from '@/utils';
import EventCard from './EventCard.vue';

// Props
const props = defineProps(['max', 'filter']);
const today = new Date().toISOString().split('T')[0];

// Store and events data
const kql = useStore();
const events = computed(() => filterPublicPages(pageFromPath('calendar', kql?.pages)?.children));

// Computed properties
const clampedEvents = computed(() => clamp(Object.values(events?.value ?? {}), props.max));
//const filteredEvents = computed(() => filterItems(clampedEvents.value, event =>   props.filter ? event.content.type === props.filter : true ));
const futureEvents = computed(() => filterItems(events.value, event => event.content.date >= today ));
</script>

<style scoped>
  nav.events {
    display: flex;
    width: var(--main-width-narrower);
    flex-wrap: wrap;
    margin: auto;
    z-index: 999;
    position: relative;
    width: ;
    justify-content: space-between;
    top: -6rem;
  }

  @media (max-width: 1080px) {
    nav.events {
      justify-content: center;
    }
  }

  nav :deep(a) {
    max-width:29rem;
    margin-left: 2rem;
    margin-right: 2rem;
  }

</style>
